import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CommonService } from '@app/service/common.service';
import { ToastrService } from 'ngx-toastr';
import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

import { BrowserModule, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-english',
  templateUrl: './english.component.html',
  styleUrls: ['./english.component.scss']
})
export class EnglishComponent extends O2OZCMS implements OnInit {

  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private titleService: Title,
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);
  }

  ngOnInit(): void {
    this.titleService.setTitle( 'KRAIA' );
  }
}
